var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2)])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }